import React, {useEffect, useState} from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import {useHistory} from 'react-router-dom'
import './style.css'
import axios from 'axios'
import {API_URL} from 'api'
import {access_token} from 'token'

export default function Tokos() {
    const history = useHistory()
    const handleClick = () => {
        history.push('/brand_page')
    }

    const [data, setData] = useState([])
    
    const datas = [...data]

    // console.log(datas[0].media.file_name)
    async function GetBrand() {
        try{
            const response = await axios.get(`${API_URL}/api/reseller/homepage/brand`)
            setData(response.data.data)
        } catch (err) {
            const errors = err.message
            console.log(errors)
        }
    }

    useEffect(() => {
        GetBrand()
    }, [])

    axios.interceptors.request.use(
        config => {
            config.headers.authorization = `bearer ${access_token}`;
            return config
        },
        error => {
            return Promise.reject(error)
        }
    )

    return (
        <Container className="container-toko">
            <h3>Toko Pilihan</h3>
            <Row>
                {
                    datas.map((item, i) => {
                        return (
                            <Col key={i} md={2}>
                                <div onClick={handleClick} className="toko-cards">
                                    <div className="card-img">
                                        <img src="asset/dashboard/toko_pilihan/img-cordova.png" alt="toko" />
                                    </div>
                                    <p>{item.username}</p>
                                </div>
                            </Col>
                        )
                    })
                }
            </Row>
        </Container>
    )
}


// const Toko = [
//     {src:"asset/dashboard/toko_pilihan/img-cordova.png", alt:"cordova", text:"Cordova Indonesia"},
//     {src:"asset/dashboard/toko_pilihan/img-cordova.png", alt:"cordova", text:"Cordova Indonesia"},
//     {src:"asset/dashboard/toko_pilihan/img-cordova.png", alt:"cordova", text:"Cordova Indonesia"},
//     {src:"asset/dashboard/toko_pilihan/img-cordova.png", alt:"cordova", text:"Cordova Indonesia"},
//     {src:"asset/dashboard/toko_pilihan/img-cordova.png", alt:"cordova", text:"Cordova Indonesia"},
//     {src:"asset/dashboard/toko_pilihan/img-cordova.png", alt:"cordova", text:"Cordova Indonesia"}

// ]
